import type { ReactNode } from 'react';
import { ShieldOff } from 'lucide-react';
import type { Permission } from '../api/types';
import { usePermission } from '../auth/permissions';
import { Card, EmptyState } from '../ui';
import { useT } from '../i18n';

/** Affiche une page « accès refusé » si l'utilisateur n'a pas la permission pour cette zone. */
export function RequirePermission({ permission, mode, children }: { permission?: Permission | Permission[]; mode?: 'all' | 'any'; children: ReactNode }) {
  const { t } = useT();
  const allowed = usePermission(permission ?? [], mode);
  if (!permission || allowed) return <>{children}</>;
  return (
    <Card>
      <EmptyState icon={<ShieldOff size={24} />} title={t('forbidden.title')} description={t('forbidden.description')} />
    </Card>
  );
}
